import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Box, useTheme } from '@mui/material'
import { useDeletePlaylist } from '../../hooks/playlist/useDeletePlaylist'
import { useFetchPlaylists } from '../../hooks/useFetchPlaylists'
import { useMountEffect } from '../../hooks/useMountEffect'
import { useShowOnDesktop } from '../../hooks/useShowOnDesktop'
import { FetchUserPlaylistsPlaylistTypeEnum as playlistTypeEnum } from '../../swagger'
import { Page } from '../Elements/PageMargins'
import DeletePlaylistConfirmationModal from '../Modals/playlist/DeletePlaylistConfirmationModal'
import ContentDetailPlaylistCard from '../Playlist/ContentDetailPlaylistCard'
import EmptyPlaylist from '../Playlist/EmptyPlaylist'

interface PlaylistsTabBCProps {
  playlistType: playlistTypeEnum
}

const PlaylistsTabBC: React.FC<PlaylistsTabBCProps> = ({ playlistType }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const theme = useTheme()
  const showOnDesktop = useShowOnDesktop()
  const { playlistsContent, triggerFetch, isLoading } = useFetchPlaylists({
    playlistType,
  })

  const [playlistToDelete, setPlaylistToDelete] = useState<number>()

  const onSuccess = () => {
    setPlaylistToDelete(undefined)
    triggerFetch()
  }
  const { deletePlaylist } = useDeletePlaylist(
     playlistToDelete,
    onSuccess
  )

  useMountEffect(triggerFetch)
  const basePath = location.pathname.split('/')[1]
  const navigateToPlaylistDetails = (playlistId: string) => {
    navigate(`/${basePath}/playlist-details/${playlistId}`)
  }

  if (
    !playlistsContent?.playlists ||
    playlistsContent?.playlists.length === 0
  ) {
    return <EmptyPlaylist isLoading={isLoading} />
  }

  return (
    <Page>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
          gap: 1,
          margin: theme.spacing(3),
          ...(showOnDesktop && {
            margin: theme.spacing(3, 2),
          }),
        }}
      >
        {playlistsContent?.playlists.map(
          ({ playlistKey, name, playlistType }) => (
            <Box
              key={playlistKey}
              sx={{ width: 'auto', flexShrink: 0, flexGrow: 0 }}
            >
              <ContentDetailPlaylistCard
                name={name}
                playlistType={playlistType}
                onClick={() =>
                  navigateToPlaylistDetails(playlistKey.toString())
                }
                onDeleteClick={() => setPlaylistToDelete(playlistKey)}
              />
            </Box>
          )
        )}
      </Box>
     {!!playlistToDelete && (
      <DeletePlaylistConfirmationModal
        isOpen
        onCancel={() => setPlaylistToDelete(undefined)}
        onConfirm={deletePlaylist}
        label="Playlist"
        confirmationMessage="This action will permanently delete the playlist and all its items. Do you wish to continue"
      />
       )}
    </Page>
  )
}

export default PlaylistsTabBC
